/** Saving and refreshing are separate operations. Never retry a write here. */
export type MasterSaveResult =
  | { saved: true; refreshFailed: false }
  | { saved: true; refreshFailed: true; refreshError: unknown };

export const saveMasterAndRefresh = async (
  save: () => Promise<unknown>,
  refresh: () => Promise<unknown>,
): Promise<MasterSaveResult> => {
  // A save error must reach the caller; no read should hide that error.
  await save();
  try {
    await refresh();
    return { saved: true, refreshFailed: false };
  } catch (refreshError) {
    return { saved: true, refreshFailed: true, refreshError };
  }
};

/** Do not display raw server errors (they may contain database details). */
export const getMasterSaveErrorMessage = (error: unknown): string => {
  const failure = error as {
    response?: { status?: number };
    request?: unknown;
    code?: string;
  } | null;
  const status = failure?.response?.status;
  if (status === 400 || status === 422) {
    return '公開先などの入力内容をサーバーが受け付けませんでした。設定内容を確認してください。';
  }
  if (status === 401 || status === 403) {
    return '認証または更新権限を確認できませんでした。入力内容を控え、ログイン状態と権限を確認してください。';
  }
  if (status === 409) {
    return '他の更新と競合しました。入力内容を控え、最新の設定を確認してください。';
  }
  if (!status || status >= 500) {
    return '保存結果を確認できませんでした。入力内容は保持しています。再送信する前に保存先の状態を確認してください。';
  }
  return '設定を保存できませんでした。入力内容は保持しています。管理者へご連絡ください。';
};
